import axiosInstance from './AxiosInstance';

export const CREDIT_TOPUP_OPEN_EVENT = 'open-credit-topup';
export const CREDIT_WALLET_UPDATED_EVENT = 'credit-wallet-updated';
export const CREDIT_CHECKOUT_STORAGE_KEY = 'credit_checkout_topup';

export function creditCheckoutPath(credits) {
  const n = Number(credits);
  if (!Number.isFinite(n) || n <= 0) return '/credits/checkout';
  return `/credits/checkout?credits=${encodeURIComponent(n)}`;
}

export function saveCreditCheckoutCredits(credits) {
  try {
    localStorage.setItem(CREDIT_CHECKOUT_STORAGE_KEY, JSON.stringify({ credits: Number(credits) }));
  } catch (e) {
    // ignore
  }
}

export function getSavedCreditCheckoutCredits() {
  try {
    const saved = localStorage.getItem(CREDIT_CHECKOUT_STORAGE_KEY);
    if (!saved) return null;
    const parsed = JSON.parse(saved);
    const n = Number(parsed?.credits);
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

export function clearCreditCheckoutStorage() {
  try {
    localStorage.removeItem(CREDIT_CHECKOUT_STORAGE_KEY);
  } catch (e) {
    // ignore
  }
}

export function dispatchCreditWalletUpdated() {
  try {
    window.dispatchEvent(new Event(CREDIT_WALLET_UPDATED_EVENT));
  } catch (e) {
    // ignore
  }
}

export function planIncludesCredits(plan) {
  if (!plan) return false;
  return plan.monthly_included_credits != null || plan.yearly_included_credits != null;
}

export function creditsWalletPath() {
  return '/credits';
}

export function creditPurchasesPath() {
  return '/credits/purchases';
}

export function creditPurchaseDetailPath(purchaseId) {
  return `/credits/purchases/${purchaseId}`;
}

export function openCreditTopUpModal() {
  try {
    window.dispatchEvent(new CustomEvent(CREDIT_TOPUP_OPEN_EVENT));
  } catch (e) {
    // ignore
  }
}

export async function getCreditOverview() {
  const res = await axiosInstance.get('/credits/overview');
  return res.data;
}

export async function getCreditBalance() {
  const res = await axiosInstance.get('/credits/balance');
  return res.data;
}

export async function previewCreditTopup(credits) {
  const res = await axiosInstance.get('/credits/preview-topup', {
    params: { credits },
  });
  return res.data;
}

export async function createCreditCheckout(credits) {
  const res = await axiosInstance.post('/payment/credit-checkout', { credits });
  return res.data;
}

export async function getCreditPurchases({
  limit = 20,
  offset = 0,
  dateFrom = null,
  dateTo = null,
} = {}) {
  const params = { limit, offset };
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;
  const res = await axiosInstance.get('/credits/purchases', { params });
  return res.data;
}

export async function getCreditPurchaseById(purchaseId) {
  const res = await axiosInstance.get(`/credits/purchases/${purchaseId}`);
  return res.data;
}

export async function getCreditPurchaseUsage(purchaseId, { limit = 20, offset = 0 } = {}) {
  const res = await axiosInstance.get(`/credits/purchases/${purchaseId}/usage`, {
    params: { limit, offset },
  });
  return res.data;
}

export async function getCreditUsage({ limit = 20, offset = 0 } = {}) {
  const res = await axiosInstance.get('/credits/usage', { params: { limit, offset } });
  return res.data;
}

export async function getCreditSettings() {
  const res = await axiosInstance.get('/credits/settings');
  return res.data;
}
